module.exports = __webpack_public_path__ + "img/kitchen-mobile-inactive.e84c10b.svg";